import React from 'react';
import Autocomplete from 'react-google-autocomplete';
import style from '../styles/form';
import { TextField } from './MaskedTextField';

const formattedPlace = (place) => {
  const formatted = {};
  place.address_components.forEach((component) => {
    component.types.forEach((type) => {
      formatted[type] = component.short_name;
    });
  });
  return {
    zip: formatted.postal_code,
    city: formatted.locality,
    state: formatted.administrative_area_level_1,
    address: place.name || `${formatted.street_number || ''} ${formatted.route || ''}`.trim(),
    county: formatted.administrative_area_level_2
  };
};

export default ({ value, onAutocomplete, id, type, placeTarget = 'address', ...props }) => (
  <TextField id={`${id}Address`} value={value} style={style.threeQuarters} {...props}>
    {typeof window.google === 'object' && typeof window.google.maps === 'object' ? (
      <Autocomplete
        style={style.autoComplete}
        placeholder=""
        value={value || ''}
        onPlaceSelected={(place) => {
          if (place.address_components) {
            const address = formattedPlace(place);
            onAutocomplete(address);
            document.getElementById(`${id}Address`).value = address[placeTarget];
          }
        }}
        componentRestrictions={{ country: 'us' }}
        types={[type]}
      />
    ) : null}
  </TextField>
);



// WEBPACK FOOTER //
// ./src/components/autocomplete.js